import { useCallback, ReactNode } from 'react'
import { Scope, ErrorBoundary } from '@sentry/react'
import getEnvironment from 'Modules/handleEnvironment'
import ErrorMessage from 'Components/SharedComponents/ErrorMessage'
import { useAppState } from 'Context/AppContext/AppContext'

export const ErrorBoundaryWithContext = ({
  children,
}: {
  children: ReactNode
}) => {
  const { userConfig } = useAppState()
  const userId = userConfig?.id

  const beforeCapture = useCallback(
    (scope: Scope) => {
      scope.setUser({
        id: String(userId),
      })

      scope.setTag('env', getEnvironment())

      scope.setExtra(
        'Segment Anonymous ID',
        analytics?.user?.()?.anonymousId?.()
      )
    },
    [userId]
  )

  return (
    <ErrorBoundary fallback={<ErrorMessage />} beforeCapture={beforeCapture}>
      {children}
    </ErrorBoundary>
  )
}
